import { createQueryHook } from '../../createQueryHook'
import { UserProfileData } from '../../types'

export default createQueryHook<undefined, UserProfileData>({
  getKey: () => ['account/my-profile'],
  getEndpoint: () => 'account/my-profile'
})
